import { Component } from "react"

import { Button } from "../ui-kit/components-branded"

export class TryAgainLater extends Component {
    static defaultProps = {
        tryAgainButtonText: "Попробовать еще раз",
    }

    constructor(props) {
        super(props)
        this.state = {
            errorMessage: this.props.errorMessage,
            resultMessage: this.props.resultMessage,
        }
    }

    setLoading = (show) => {
        this.setState({ loading: show })
    }
    setResultMessage = (text) => {
        this.setState({ resultMessage: text, errorMessage: undefined })
    }
    setErrorMessage = (text) => {
        this.setState({ errorMessage: text, resultMessage: undefined })
    }

    render() {
        const ButtonComponent = this.props.buttonComponent
        return (
            <>
                {this.props.children}
                {this.state.resultMessage && (
                    <div
                        className="dismissible-result-message alert alert-success alert-dismissible fade show"
                        role="alert"
                    >
                        {this.state.resultMessage}
                        <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                            onClick={() => this.setState({ resultMessage: "" })}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                {this.state.errorMessage && (
                    <div
                        className="dismissible-error-message alert alert-danger alert-dismissible fade show"
                        role="alert"
                    >
                        {this.state.errorMessage}
                        <button
                            type="button"
                            className="close"
                            data-dismiss="alert"
                            aria-label="Close"
                            onClick={() => this.setState({ errorMessage: "" })}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                )}
                <div className="general-button-container">
                    {this.props.button ? (
                        this.props.button
                    ) : this.props.buttonComponent ? (
                        <ButtonComponent
                            loading={this.state.loading}
                            className={
                                this.state.loading || !this.props.enabled
                                    ? this.props.buttonClassDisabled
                                    : this.props.buttonClassEnabled
                            }
                            onClick={
                                this.props.enabled
                                    ? this.props.tryAgainFunction || this.props.onClick
                                    : null
                            }
                        >
                            {this.props.tryAgainButtonText}
                        </ButtonComponent>
                    ) : (
                        <Button
                            color="primary"
                            isLoading={this.state.loading}
                            className={this.props.className}
                            onClick={
                                this.props.enabled
                                    ? this.props.tryAgainFunction || this.props.onClick
                                    : null
                            }
                        >
                            {this.props.tryAgainButtonText}
                        </Button>
                    )}
                </div>
            </>
        )
    }
}

TryAgainLater.defaultProps = {
    enabled: true,
}
